import { render, staticRenderFns } from "./bottomBtn.vue?vue&type=template&id=3d332fed&"
import script from "./bottomBtn.vue?vue&type=script&lang=js&"
export * from "./bottomBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports